/**
 * CPG mobile navigation (P1 chrome rebuild) — behavior for snippets/cpg-mobile-nav.liquid.
 * Replaces the Marnello header-mobile-menu drawer. Opens the full-screen sheet,
 * drills the canonical category tree one level per screen (Back climbs one level),
 * locks body scroll while open. Markup + CSS live in the snippet; category data is
 * server-rendered from cpg.category_menu (same source as the desktop mega-menu).
 */
(function () {
  'use strict';

  function init(root) {
    if (root.__cpgMnavInit) return;
    root.__cpgMnavInit = true;

    var openers = document.querySelectorAll('[data-cpg-mnav-open]'); // burger + tab-bar "Shop"
    var closers = root.querySelectorAll('[data-cpg-mnav-close]');
    var levels = Array.prototype.slice.call(root.querySelectorAll('[data-mnav-level]'));
    var sheet = root.querySelector('.cpg-mnav__sheet'); // the single scroll region
    var current = 'root';

    function show(id, deeper) {
      levels.forEach(function (l) {
        var lid = l.getAttribute('data-mnav-level');
        if (lid === id) {
          l.classList.add('is-active'); l.classList.remove('is-past');
        } else if (lid === current && deeper) {
          l.classList.remove('is-active'); l.classList.add('is-past');
        } else {
          l.classList.remove('is-active', 'is-past');
        }
      });
      current = id;
      // levels no longer scroll themselves — the whole sheet does; reset it so a
      // drill/back always lands at the top of the new level.
      if (sheet) sheet.scrollTop = 0;
    }

    function open() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.documentElement.style.overflow = 'hidden';
      // hide the max z-index live-chat launcher so it can't sit over the drawer
      document.documentElement.classList.add('cpg-mnav-open');
      show('cat', false); // category browser starts at the department list
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('cpg-mnav-open');
    }

    // stopPropagation shields these from the legacy header's document-level
    // click/pointer handlers (Marnello drawer scripts) that could otherwise
    // race and close the sheet on the same tap.
    openers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(); }); });
    closers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    root.querySelectorAll('[data-mnav-drill]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); show(b.getAttribute('data-mnav-drill'), true); });
    });
    root.querySelectorAll('[data-mnav-back]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); show(b.getAttribute('data-mnav-back'), false); });
    });
  }

  function boot() {
    var root = document.querySelector('[data-cpg-mnav]');
    if (root) init(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
